module.exports = require("../../../lib").google.type;
